module.exports = __webpack_public_path__ + "static/spokoj_main_1-8c9407dfb7fe3ed92f3d9635abce7549.png";